import { render, staticRenderFns } from "./index.vue?vue&type=template&id=11b84297&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SingleNumber: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/single/number.vue').default,SingleNormal: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/single/normal.vue').default,SingleCols: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/single/cols.vue').default,SingleFullscreen: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/single/fullscreen.vue').default,LayoutSitemap: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/layout/sitemap.vue').default})
